import React, { Suspense } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Button,
  IconButton,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import AmplitudeAnalytics from '../../../../../shared/services/AmplitudeAnalytics';

const Logo = React.lazy(() => import('./Logo'));

export default function PageHeader() {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const handleChangePlanClick = () => {
    void navigate(-1);
    AmplitudeAnalytics.trackPlanChange();
  };

  return (
    <Box sx={{ width: 1, display: 'flex' }}>
      <Box sx={{ position: 'absolute' }}>
        {isSmallScreen ? (
          <IconButton color="primary" onClick={handleChangePlanClick}>
            <ArrowBackIcon />
          </IconButton>
        ) : (
          <Button startIcon={<ArrowBackIcon />} onClick={handleChangePlanClick}>
            {t('checkout.change-plan')}
          </Button>
        )}
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexGrow: 1,
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <Suspense fallback={null}>
          <Logo width={isSmallScreen ? 200 : 300} />
        </Suspense>
      </Box>
    </Box>
  );
}
